/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Footnote_SeeInputs */

const en_common_footnote_see = /** @type {(inputs: Common_Footnote_SeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`see footnote`)
};

/**
* | output |
* | --- |
* | "see footnote" |
*
* @param {Common_Footnote_SeeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_footnote_see = /** @type {((inputs?: Common_Footnote_SeeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Footnote_SeeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_footnote_see(inputs)
});